import axios from "axios";
import Cookies from "js-cookie";
import { PAY_BASE_URL } from "./constants";

export async function getInfoCheckoutSycapay(plan: string) {
  try {
    const token = Cookies.get("user");
    const response = await axios.get(
      `${PAY_BASE_URL}/webapp/payment/pegase/checkout?idPlan=${plan}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = response.data;
    return data;
  } catch (error) {
    console.log(
      "🚀 ~ file: request.ts:212 ~ getInfoCheckoutSycapay ~ error:",
      error
    );
    return { error: true, msg: "Erreur interne inconnue" };
  }
}

export async function postCheckoutSycapay(body: any) {
  try {
    const token = Cookies.get("user");
    const response = await axios.post(
      `${PAY_BASE_URL}/webapp/payment/pegase/checkout`,
      body,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function getStatusSycapay(transactionId: string) {
  try {
    const token = Cookies.get("user");
    const response = await axios.get(
      `${PAY_BASE_URL}/webapp/payment/pegase/status?tid=${transactionId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = response.data;
    return data;
  } catch (error) {
    console.log(
      "🚀 ~ file: request.ts:212 ~ getInfoCheckoutSycapay ~ error:",
      error
    );
    return { error: true, msg: "Erreur interne inconnue" };
  }
}

export async function postFinishSycapay(body: any) {
  try {
    const token = Cookies.get("user");
    const response = await axios.post(
      `${PAY_BASE_URL}/webapp/payment/pegase/transaction`,
      body,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function postValidateCoupon(body: any) {
  try {
    const token = Cookies.get("user");
    const response = await axios.post(
      `${PAY_BASE_URL}/webapp/payment/pegase/coupon`,
      body,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}
